// extracted by mini-css-extract-plugin
export default {"actions":"styles_actions__zMStV","actionButton":"styles_actionButton__873RD","spin":"styles_spin__pw+lb"};